import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const vehiclesSalesRequests = {
        isLoading: false,
        init() {
            $(document).on('click', '.longterm-select-model-btn', this, this.selectModel);
            $(document).on('click', '#vehicle-sale-submit-form', this, this.send);
            $(document).on('click', '#check-marketing', this, this.selectAllMarketing);
        },
		selectAllMarketing(event) {
			const _this = event.data;

			if ($('#check-marketing').is(':checked')) {
				$('#marketing_phone').prop('checked', true);
				$('#marketing_email').prop('checked', true);
				$('#marketing_sms').prop('checked', true);
				$('#marketing_newsletter').prop('checked', true);
			} else {
				$('#marketing_phone').prop('checked', false);
				$('#marketing_email').prop('checked', false);
				$('#marketing_sms').prop('checked', false);
				$('#marketing_newsletter').prop('checked', false);
			}
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('.vehicles-sales-form').find('.form-control').removeClass('is-invalid');
			$('.vehicles-sales-form').find('.form-check-input').removeClass('is-invalid');

			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			// if (!$('#terms_and_conditions_' + offerId).is(":checked")) {
			// 	$('#terms_and_conditions_' + offerId).addClass('is-invalid');
			// 	errors = true;
			// }

			if (errors) {
				Swal.fire({
					icon: 'error',
					title: 'Error!',
					html: $(this).data('alert-text')
				});
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'vehicle_id=' + $(element).data('id');
			values += '&name=' + $('#name').val();
			values += '&phone=' + $('#phone').val();
			values += '&email=' + $('#email').val();
			values += '&message=' + $('#message').val();
			values += '&marketing_phone=' + ($('#marketing_phone').is(':checked')?1:0);
			values += '&marketing_email=' + ($('#marketing_email').is(':checked')?1:0);
			values += '&marketing_sms=' + ($('#marketing_sms').is(':checked')?1:0);
			values += '&marketing_newsletter=' + ($('#marketing_newsletter').is(':checked')?1:0);
			values += '&_token=' + $('meta[name="csrf-token"]').attr('content');
			$.ajax({
	            type: "POST",
	            url: baseURL + "/vehicle-sales/send",
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

						Swal.fire({
							icon: 'error',
							title: 'Error!',
							html: $(element).data('alert-text')
						});
                        return false;
                    }

					if (response.status == 1) {
						$('.vehicles-sales-form').find('.form-control').val('');
						//$('#terms_and_conditions_' + offerId).prop('checked', false);
						$('#check-marketing').prop('checked', false);
						$('#marketing_phone').prop('checked', false);
						$('#marketing_email').prop('checked', false);
						$('#marketing_sms').prop('checked', false);
						$('#marketing_newsletter').prop('checked', false);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					Swal.fire({
						icon: 'error',
						title: 'Error!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

	if ( $('.vehicles-sales-form').length ) {
        vehiclesSalesRequests.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/vehicles-sales-requests.js